module.exports = __webpack_public_path__ + "static/media/i-ico-white.db434a56.svg";